import React from 'react'
import inputComponents from './inputComponents'
import { checkTextTranslation, checkTranslation, getObject, setObject, translate } from '../../utils/useful'
import SidebarView from '../SidebarView'
import FormViewer from '../FormViewer'
import LoaderButton from '../LoaderButton'
import ButtonAnimated from '../buttons/ButtonAnimated'

class ExtraSettingsInput extends React.Component {
    state = {
        errors: {},
        data: {},
        width: window.innerWidth,
        show: false,
        countries: [],
        actions: {
            cancel: { key: "cancel", label: "{{lang}}cancel", color: '#777', bgColor: '#eee', function: this.hideModal },
            submit: { key: "submit", label: "{{lang}}add", bgColor: 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', color: '#fff', function: this.addNew, loader: "isPostingData" },

        }
    }

    componentDidMount() {
        // console.log('this.props', this.props);
        // window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        // window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {


        if ((this.props.initData !== prevProps.initData) || (this.props.headers !== prevProps.headers)) {

            this.init()
        }
    }
    backButton() {
        if (this.state.hasBack) {
            return (
                <div className=" mld-2"  >
                    <div className="" >
                        <LoaderButton
                            onClick={this.formBackPage}
                            // isLoading={this.state[prop.loader]}
                            text={translate('Back')}
                            // type={"Oval"}
                            className={"text-bold text-small text-center flexcc w-100 br-20 py-1  " + (this.state.canSubmit ? '' : 'gray-image')}
                            background={'#eee'}
                            width={20}
                            height={20}
                            color={'#777'}
                        />
                    </div>
                </div>
            )

        }
    }

    getForm = () => {
        // console.log(this.validator())
        if (this.validator()) {
            return this.state.data ? this.state.data : {}
        } else {
            return null
        }
    }



    init = () => {
        this.makeInitValue(this.props.initData)
    }


    validator() {
        let valid = true
        let errors = {}
        this.props.headers.forEach(header => {
            if (header.information?.required) {

                let value = getObject(this.state.data, header.key)

                if (header.type == 'ImageInput' || header.type == 'FileInput') {

                    if (!value || value === '') {
                        value = getObject(this.state.data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
                if (header.type == 'PhoneInput') {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value.length < 14) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
            }
        })

        this.setState({ errors })
        return valid
    }

    makeInitValue(rawData) {

        let data = rawData
        if (data == null) {
            data = {}
        }
        if (this.props.headers) {

            this.props.headers.forEach(header => {
                if (data[header.key] == null && header.information?.default != null) {
                    data[header.key] = header.information?.default
                }
            });
        }

        this.setState({ data: data, show: true }, () => {
            // this.setFormWidth()
        })

    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width })
        }
    }



    addNew = () => {
        let form = this.form.getForm()
        if (form) {

            let data = this.props.data
            if(form.defaultWarehouse == true && Array.isArray(data)){
                for (let i = 0; i < data.length; i++) {
                    const element = data[i];
                    element.defaultWarehouse = false
                }
            }
            if (!Array.isArray(data)) {
                data = []
            }
            data.push(form)
            this.props.changeValue(this.props.header.key, data)
        }
        this.hideModal()
    }
    editSelected = () => {
        let form = this.form.getForm()
        if (form) {

            let data = this.props.data
            if(form.defaultWarehouse == true && Array.isArray(data)){
                for (let i = 0; i < data.length; i++) {
                    const element = data[i];
                    element.defaultWarehouse = false
                }
            }
       data[this.state.selectedIndex]= form
            this.props.changeValue(this.props.header.key, data)
        }
        this.setState({editData : null , selectedIndex : null}, ()=>{

            this.hideModal()
        })
    }

    removeRow = (index) => {
        let data = this.props.data
        // if (!Array.isArray(data)) {
        //     data = []
        // }
        // data.push({})
        data.splice(index, 1)
        this.props.changeValue(this.props.header.key, data)
    }
    editRow = (prop, index) => {
        this.setState({ editData: prop ,selectedIndex: index }, () => {
            this.open()
        })

    }


    changeFiles = (files, key, extra) => {
        // let data = this.state.data ?? {}

        // if (data['**files'] == null) {
        //     data['**files'] = {}
        // }
        // value.formType = ''

        // this.props.header.information.headers.forEach(header => {
        //     if (header.key == key) {
        //         value.formType = header.type
        //         // value.single = header.information?.single
        //     }
        // });

        // data['**files'][key] = value
        // console.log(data)
        // this.setState({ data })
        console.log(extra)
        // console.log(files)

        this.props.changeValue('**files', { [this.props.header.key + '.' + extra?.index + "~" + key]: files }, { append: 'object' })
        // this.props.changeValue('**files.' + this.props.header.key + '.' + extra?.index + "~" + key, files)

        // this.props.changeValue('**files', { [this.props.header.key+'!!' + '.' + key ]: files })

    }
    open = () => {
        this.settingsModal.open()
        this.setState({ showModal: true })

    }

    close = () => {
        this.setState({ show: false }, () => {

        })
        // this.onClose()
    }

    onClose() {
        this.hideModal()

    }
    showModal = () => {
        this.open()


    }


    hideModal = () => {

        this.settingsModal.hideModal()
        if (this.form) {
            this.form.clearForm()
        }
        setTimeout(() => {
            this.setState({ showModal: false })
        }, 500);
    }


    changeValue = (key, value, extra) => {

        let data = this.props.data
        let index = extra.index
        if (Array.isArray(data)) {
            data = setObject(data, key, value, false, index)
            this.props.changeValue(this.props.header.key, data)
        }
    }



    formColBuilder(col) {
        let finalCol = 'col-12'

        // if (100 < this.state.width && col) {
        finalCol = 'col-' + col
        // }

        return finalCol
    }

    // renderHeader(headers) {
    //     if (headers) {
    //         return (headers.map((header, index) => {
    //             return (
    //                 <div key={index} className={" mb-1 form-label  p-0 text-capitalize text-semibold pt-2 " + this.formColBuilder(header.col)} >
    //                     <label className={'text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
    //                     {header.information?.hint && (
    //                         <div className="mx-1 text-start text-smallest">
    //                             <div style={{ color: '#9ab', fontWeight: '500' }}>{checkTextTranslation(header.information?.hint)}</div>
    //                         </div>
    //                     )}
    //                 </div>
    //             )
    //         }))
    //     }
    // }


    // renderBody(headers, rawData, index) {
    //     return (
    //         // <div className="flexcc p-1">

    //         // {
    //         headers && headers.map((header, hindex) => {
    //             let Component = inputComponents[header.type]
    //             // console.log(rawData)
    //             let data = getObject(rawData, header.key)//data[header.key] ? data[header.key] : ''
    //             let files
    //             if (rawData && rawData['**files']) {
    //                 files = getObject(rawData['**files'], header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
    //             }


    //             if (data == null && header.information?.default != null) {
    //                 data = header.information?.default
    //             }

    //             if (Component) {
    //                 return (
    //                     <div key={hindex} className={" mb-0 p-0 " + this.formColBuilder(header.col)} >

    //                         <div className="row m-0 prd-2">

    //                             <div className="col-12 p-0 mb-2">
    //                                 <div className={"flexc " + (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : 'default-subinput-view'))} >
    //                                     {header.information?.icon && (
    //                                         <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
    //                                     )}
    //                                     <Component extra={{ index }} header={header} data={data} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} variables={this.props.variables} optionsList={this.props.optionsList} />
    //                                 </div>
    //                             </div>



    //                             {this.props.errors && this.props.errors[header.key] && (
    //                                 <div className="col-12 mt-1 mld-2 text-start">
    //                                     <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
    //                                 </div>
    //                             )}

    //                             {this.state.errors && this.state.errors[header.key] && (
    //                                 <div className="col-12 mt-1 mld-2 text-start">
    //                                     <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
    //                                 </div>
    //                             )}

    //                         </div>
    //                     </div>
    //                 )
    //             }
    //         })
    //         //     }
    //         // </div>

    //     )
    // }
    openSettings() {

        this.open()
        this.init()

    }



    render() {
        // let headers = this.props.header.information?.headers
        // console.log(this.props.data)
        // if (this.state.show) {
        return (
            <>
                <SidebarView width={this.props.width} ref={el => this.settingsModal = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '60%', lg: "50%", xl: "40%" }} onClosed={this.onClose} >
                    <div className="h-100">
                        <div className="h-100" ref={el => this.container = el} style={{ backgroundColor: '#fff', overflow: 'auto' }}>



                            <div className="flexcb px-2 py-1" style={{ position: 'sticky', top: 0, zIndex: 1, boxShadow: '0px 0px 0px #10101010', borderBottom: '1px solid #f6f6f6', background: this.props.background ?? 'linear-gradient(to right, #fff , #fff)', backgroundColor: '#fff' }}>
                                <div className="flexc w-100  py-2 px-3">
                                    {/* <button onClick={() => this.props.lastStage()} className='flexcc mrd-3'> */}
                                    {/* <div className='rotate-180 br-50 ws-25 hs-25 flexcc' style={{ background: '#ffffffcd' }}> */}
                                    {/* <img  height='22px' className="mld-3" src="/assets/icons/applets/general/text.png" alt="" /> */}
                                    {/* </div> */}
                                    {/* </button> */}
                                    {/* <p className="color-white">{translate(`Add New Provider`)}</p> */}
                                    <div className="flexcc br-4 text-big color-white text-bold" style={{ height: 22, width: 22, background: 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))' }}>
                                        <p>+</p>
                                    </div>
                                    <p className="text-bold text-normal px-1">{(checkTranslation(this.props.header.information.title) ?? translate(this.state?.editData? "useful.edit" : "New Record"))}</p>

                                </div>
                                {/* <button disabled={this.props.provider?.hubs?.length == 0} onClick={() => this.props.changeStage('form')} className="flexcb p-1 px-2 flex-1 " style={{borderRadius:6, background: '#00000020', border: '1px solid #d8d8d800' }}>
                                <img className='invert' src="/assets/icons/useful/plus.svg" height={20} />
                                <div className="" style={{}} >
                                <p className="text-small" style={{ color: '#fafafa' }}>{translate('Submit')}</p>
                                </div>
                                <div className=' default-btn-icon  ws-25 hs-25 flexcc' style={{}}>
                                <img className='invert' src="/assets/icons/useful/plus.svg" height={20} />
                                </div>
                            </button> */}

                                <div className="flexce w-100  px-2">







                                    <div className=" mld-2"  >
                                        <div className="" >
                                            <LoaderButton
                                                onClick={this.hideModal}
                                                isLoading={false}
                                                text={translate("cancel")}
                                                // type={"Oval"}
                                                className={"text-bold text-small text-center flexcc w-100 br-20 py-1  "}
                                                background={'#eee'}
                                                width={20}
                                                height={20}
                                                color={'#777'}
                                            />
                                        </div>
                                    </div>
                                    {!this.state.editData ? (

                                        <div className=" mld-2"  >
                                            <div className="" >
                                                <LoaderButton
                                                    onClick={this.addNew}
                                                    isLoading={false}
                                                    text={translate("add")}
                                                    // type={"Oval"}
                                                    className={"text-bold text-small text-center flexcc w-100 br-20 py-1  "}
                                                    background={'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))'}
                                                    width={20}
                                                    height={20}
                                                    color={'#fff'}
                                                />
                                            </div>
                                        </div>

                                    ):(
                                        <div className=" mld-2"  >
                                        <div className="" >
                                            <LoaderButton
                                                onClick={this.editSelected}
                                                isLoading={false}
                                                text={translate("done")}
                                                // type={"Oval"}
                                                className={"text-bold text-small text-center flexcc w-100 br-20 py-1  "}
                                                background={'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))'}
                                                width={20}
                                                height={20}
                                                color={'#fff'}
                                            />
                                        </div>
                                    </div>

                                    )}

                                </div>

                            </div>



                            {/* {this.state.showModal && ( */}
                            <div className="w-100 mt-2 px-2 pt-2">
                                <FormViewer ref={el => this.form = el} headers={this.props.header.information.headers} pages={this.props.pages} initData={this.state.editData} width={this.props.width} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} setFormStatus={this.setFormStatus} scrollToTop={this.scrollToTop} />
                            </div>




                            {/* <div className="" style={{}}>


                            <div className="flexce w-100 mb-2 px-3">
                            {Object.values(this.state.actions).map((prop, index) => {
                                return (
                                    <div className=" mld-2"  >
                                            <div key={index} className="py-2" >
                                            <LoaderButton
                                            onClick={prop.function}
                                            isLoading={this.state[prop.loader]}
                                            text={checkTranslation(prop.label)}
                                            className="text-bold text-small text-center flexcc w-100 br-6 py-2  "
                                            background={prop.bgColor}
                                            width={20}
                                                    height={20}
                                                    color={prop.color}
                                                />
                                                </div>
                                        </div>
                                        )
                                })}
                                </div>
                        </div> */}


                        </div>
                    </div>
                </SidebarView>
                <div>


                    {console.log('object', this.props.data)}
                    {Array.isArray(this.props.data) && this.props.data?.map((prop, index) => {
                        return (
                            <div className="flexc w-100 position-relative mb-2" key={index}>

                                {(!this.props.header.information?.removeDisabled) && (
                                    <>
                                        {!prop['**notRemoveable'] && (
                                            <button onClick={() => this.removeRow(index)} className="flexcc p-1 position-absolute  " style={{ zIndex: 0, top: 0, right: 0 }} >
                                                <img src="/images/remove.png" width="20px" />
                                            </button>
                                        )}

                                        {/* {prop['**notRemoveable'] && (
                                            <div style={{ width: 26 }}></div>
                                        )} */}
                                    </>
                                )}
                                {(!this.props.header.information?.removeDisabled) && (
                                    <>
                                        {!prop['**notEditable'] && (
                                            <button onClick={() => this.editRow(prop, index)} className="flexcc p-1 position-absolute  " style={{ zIndex: 0, top: 0, right: 30 }} >
                                                <img src="/images/edit.png" width="20px" />
                                            </button>
                                        )}
                                    </>
                                )}
                                {(prop.defaultWarehouse) && (
                                    <>
                                        <div className="flexcc p-1 position-absolute  " style={{ zIndex: 0, top: 0, right: 100 }} >
                                            <p> {translate("default")} </p>
                                        </div>
                                    </>
                                )}

                                <div key={index} className=" w-100" style={{ flexWrap: 'nowrap' }}>
                                    <p>{prop.warehouseName}</p>
                                    {/* {this.renderBody(headers, prop, index)} */}
                                </div>
                            </div>

                        )
                    })}


                    <button onClick={() => this.openSettings()} className='px-1 py-1  flexcb w-100 h-100 ' style={{ background: " #f6f6f6'", borderRadius: 8, color: '#000', transition: 'all 0.5s', boxShadow: '0px 0px 10px #10101030', border: '1px solid #eee' }}>
                        <p className='text-small text-semibold mld-3 mrd-3 p-1 flexcc ' style={{ whiteSpace: 'nowrap' }}>{translate("Add Inventory")}</p>


                    </button>
                    {/* )} */}
                </div>
            </>
        )
        // } else {
        // return (

        // }
    }
}

export default ExtraSettingsInput;